// extracted by mini-css-extract-plugin
export default {"button":"AddButton_button__T82HC","iconWrapper":"AddButton_iconWrapper__aWXeB","textWrapper":"AddButton_textWrapper__051iF"};